import React from "react";
import { Outlet } from "react-router-dom";
import { AuthProvider } from "./AuthContext";

// The wrapper class scopes CiodsConnect.css so it cannot restyle
// the other CIODS applications.
export default function ConnectApp() {
  return (
    <AuthProvider>
      <div className="ciods-connect">
        <Outlet />
      </div>
    </AuthProvider>
  );
}